// What a crash screen knows beyond the error itself: React Router's `onError` (main.tsx) reports
// every render error its error boundaries catch, with React's component stack. It is logged to the
// console at once (so a crash on a phone can be read from the remote inspector) and kept here by
// error, so the error screen's collapsed details (shell/RouteError.tsx) can carry it into a flag.
import type { ErrorInfo } from 'react';
import { recordError } from '../health/report';

const stacks = new WeakMap<object, string>();

export interface CrashInfo {
  location?: { pathname: string; search?: string };
  pattern?: string;
  errorInfo?: ErrorInfo;
}

/** RouterProvider `onError`: log the error with its component stack and remember the stack. */
export function logCrash(error: unknown, info: CrashInfo = {}): void {
  const componentStack = info.errorInfo?.componentStack ?? '';
  if (componentStack && error && typeof error === 'object') stacks.set(error, componentStack);
  const where = info.location ? `${info.location.pathname}${info.location.search ?? ''}` : '';
  // phone health: the crash goes into the device's error log, scrubbed (health/report.ts)
  recordError('render', error);
  console.error(`[crash] ${where}${info.pattern ? ` (route ${info.pattern})` : ''}`, error, componentStack ? `\ncomponent stack:${componentStack}` : '');
}

/** The component stack logged for this error, or '' (loader errors and older reports have none). */
export function componentStackOf(error: unknown): string {
  return error && typeof error === 'object' ? (stacks.get(error) ?? '') : '';
}
